import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { sdk } from '@/services/sdk';
import { PageHeader } from '@/components/kit';
import { BackLink } from '@/components/record';
import CustomerForm, { blankCustomer } from '@/components/admin/CustomerForm';
import { committed } from '@/shared/data';

export const route = { path: '/admin/customers/new', layout: 'owner', access: "['Admin_c','Staff_c'].includes(profile)" };

export default function NewCustomer() {
  const navigate = useNavigate();
  const [initial] = useState(blankCustomer);
  const [saving, setSaving] = useState(false);

  async function create(payload) {
    setSaving(true);
    try {
      const res = await sdk.table('customers_c').create(payload);
      const saved = committed(res, 'Customer added');
      if (!saved) return;
      navigate(saved.Id ? `/admin/customers/${saved.Id}` : '/admin/customers');
    } finally {
      setSaving(false);
    }
  }

  return (
    <div className="mx-auto max-w-5xl">
      <BackLink to="/admin/customers" label="Back to Customers" />
      <PageHeader
        eyebrow="Customers"
        title="New customer"
        description="For someone who orders by DM. They can still sign up later with the same email."
      />
      <CustomerForm initial={initial} onSubmit={create} saving={saving} submitLabel="Add customer" busyLabel="Adding…" cancelTo="/admin/customers" />
    </div>
  );
}
